import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCouponList = async (params: object) => {
  return await GET({ url: Api.queryCouponList, params, showError: false })
}
export const acquireCoupon = async (params: object) => {
  return await GET({ url: Api.acquireCoupon, params, showError: false })
}
